export default __webpack_public_path__ + "static/media/PinkBall.a353a4c1.svg";